import { api } from "..";

export const getEstimateItems = async (queryParams) => {
  const estimateId = queryParams.estimateId;
  return await api.get(`/api/estimates/${estimateId}/items`, { params: queryParams });
};

export const getEstimateItemById = async (estimateId, id) => {
  return await api.get(`/api/estimates/${estimateId}/items/${id}`);
};

export const createEstimateItem = async (estimateId, data) => {
  return await api.post(`/api/estimates/${estimateId}/items`, data);
};

export const updateEstimateItem = async (estimateId, id, data) => {
  return await api.put(`/api/estimates/${estimateId}/items/${id}`, data);
};

export const deleteEstimateItem = async (id: number) => {
  return await api.delete(`/api/estimates/items/${id}`);
};

export const getEstimateReport = async (estimateId) => {
  return await api.get(`/api/estimates/${estimateId}/report`);
};
